import { useState } from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import { FaTrash } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useFetch, useMutate } from "../../../hooks/queries";

const SyncTerms = () => {
  const [selectedTerm, setSelectedTerm] = useState({});
  const [showModal, setShowModal] = useState(false);

  const {
    data: termsResponse,
    isPending,
    isLoading,
    isFetching,
    refetch: refetchTerms,
  } = useFetch({
    queryKey: ["terms"],
    url: process.env.REACT_APP_API_URL + "Terms/GetTerms",
    method: "GET",
  });

  const terms = termsResponse?.content || termsResponse?.data?.content || [];

  const deleteTermMutation = useMutate({
    mutationKey: ["delete-term"],
    url: (termId) =>
      process.env.REACT_APP_API_URL + "Terms/DeleteTerm/" + termId,
    method: "DELETE",
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        toast.success("Term deleted");
        setShowModal(false);
        setSelectedTerm({});
        refetchTerms();
      }
    },
  });

  const handleDeleteModal = (row) => {
    setShowModal(true);
    setSelectedTerm(row);
  };

  const deleteTerm = () => {
    if (!selectedTerm?.canvasApitermId) return;
    deleteTermMutation.mutate(selectedTerm.canvasApitermId);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      width: "290px",
    },
    {
      name: "Term Id",
      selector: (row) => row.sisTermId,
      width: "190px",
    },
    {
      name: "Start At",
      selector: (row) => moment(row.startAt).format("DD-MM-yyyy hh:mm A"),
      width: "190px",
    },
    {
      name: "End At",
      selector: (row) => moment(row.endAt).format("DD-MM-yyyy hh:mm A"),
    },
    {
      name: "Operator",
      selector: (row) => (row.accountId == 1 ? "Bloom" : "Taaleem"),
    },
    // {
    //   name: 'Options',
    //   selector: (row) => (
    //     <button
    //       className='btn btn-sm btn-icons btn-danger'
    //       onClick={() => handleDeleteModal(row)}
    //     >
    //       <FaTrash />
    //     </button>
    //   ),
    //   width: '120px',
    // },
  ];

  const tableLoading = isPending || isLoading || isFetching;

  return (
    <>
      <div className="container-fluid mt-15">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Terms</h3>
              </div>
              <div className="card-body p-0">
                <DataTable
                  columns={columns}
                  data={terms}
                  progressPending={tableLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>Delete Term</Modal.Header>
        <Modal.Body>Are you sure you want to detele this term?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary btn-sm mr-5"
            onClick={() => {
              setShowModal(false);
              setSelectedTerm({});
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-success btn-sm"
            onClick={deleteTerm}
            disabled={
              deleteTermMutation.isLoading || deleteTermMutation.isPending
            }
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SyncTerms;
